

const productType = {
    // product
    START_FETCHING_PRODUCT:"START_FETCHING_PRODUCT",
    SUCCESS_FETCHIED_PRODUCT:"SUCCESS_FETCHIED_PRODUCT",
    FAILURE_FETCHED_PRODUCT:"FAILURE_FETCHED_PRODUCT",

    //search params
    CHANGE_PAGE_PARAMS:"CHANGE_PAGE_PARAMS",
    CHANGE_SUBJECT_PARAMS:"CHANGE_SUBJECT_PARAMS",
    CHANGE_GRADE_PARAMS:"CHANGE_GRADE_PARAMS",

}

export default productType

